import { combineReducers } from 'redux';
import buscaDeInsumos from './slices/buscaDeInsumos.slice';

const reducer = combineReducers({
  buscaDeInsumos
})

export default reducer;
